import {
  ArrowLeftIcon,
  ArrowRightIcon,
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
} from '@radix-ui/react-icons';
import { ClassroomControlButton } from './ClassroomControlButton';

/** All controls share the existing replay/research cursor; no rule processing here. */
export function HomeworkMoveControls({
  value,
  max,
  disabled = false,
  busy = false,
  label,
  onChange,
}: {
  readonly value: number;
  readonly max: number;
  readonly disabled?: boolean;
  readonly busy?: boolean;
  readonly label?: string;
  readonly onChange: (value: number) => void;
}) {
  return (
    <div className="grading-move-controls" aria-label="棋盘手数导航">
      <div className="grading-move-buttons">
        <ClassroomControlButton
          busy={busy}
          type="button"
          aria-label="回到初始局面"
          disabled={disabled || value === 0}
          onClick={() => onChange(0)}
        >
          <DoubleArrowLeftIcon aria-hidden="true" />
        </ClassroomControlButton>
        <ClassroomControlButton
          busy={busy}
          type="button"
          disabled={disabled || value === 0}
          onClick={() => onChange(Math.max(0, value - 1))}
        >
          <ArrowLeftIcon aria-hidden="true" />
          上一手
        </ClassroomControlButton>
        <span title={label} aria-live="polite">
          {label !== undefined && max === 0 ? label : `第 ${value} / ${max} 手`}
        </span>
        <ClassroomControlButton
          busy={busy}
          type="button"
          disabled={disabled || value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
        >
          下一手
          <ArrowRightIcon aria-hidden="true" />
        </ClassroomControlButton>
        <ClassroomControlButton
          busy={busy}
          type="button"
          aria-label="跳到最后一手"
          disabled={disabled || value >= max}
          onClick={() => onChange(max)}
        >
          <DoubleArrowRightIcon aria-hidden="true" />
        </ClassroomControlButton>
      </div>
      <input
        type="range"
        aria-label="棋盘回放进度"
        aria-valuetext={`第 ${value} 手，共 ${max} 手`}
        min={0}
        max={Math.max(1, max)}
        step={1}
        value={value}
        disabled={disabled || max === 0}
        aria-disabled={disabled || max === 0 || busy}
        aria-busy={busy}
        onPointerDown={(event) => {
          if (busy) event.preventDefault();
        }}
        onKeyDown={(event) => {
          if (busy && event.key !== 'Tab') event.preventDefault();
        }}
        onChange={(event) => {
          // Keep the accepted cursor and native appearance while the server validates a move.
          if (busy || disabled || max === 0) return;
          onChange(Number(event.currentTarget.value));
        }}
      />
    </div>
  );
}
